import { useContext, useEffect } from 'react'
import { useUnleashContext } from '@unleash/proxy-client-react'

import { DeviceErrorBoundary, ErrorPage } from 'components'
import { useHideSplashScreen } from 'hooks'
import { AppErrorContext } from './contexts/AppErrorContext'
import { useConnectedUserContext } from './contexts/ConnectedUserContext'
import { AppThemeContext } from './providers/AppThemeProvider'

export const AppErrorBoundary = ({ children }) => {
  const appTheme = useContext(AppThemeContext)
  const iam = useConnectedUserContext()
  const { error } = useContext(AppErrorContext)
  const updateContext = useUnleashContext()
  const { hideSplashScreen } = useHideSplashScreen()

  useEffect(() => {
    if (error) hideSplashScreen()
  }, [error, hideSplashScreen])

  useEffect(() => {
    if (error && iam?.accountKey) {
      updateContext({ properties: { accountKey: iam?.accountKey } })
    }
  }, [error, updateContext, iam?.accountKey])

  return (
    <DeviceErrorBoundary isDeviceError={error === 'mobile-access'}>
      {!error ? children : <ErrorPage chameleonTheme={appTheme.chameleonTheme} errorCode={error} />}
    </DeviceErrorBoundary>
  )
}
